import { type Meta } from '../types/docs';

const META: Meta = {
  description: 'User duplicated a canvas',
  name: 'duplicated_canvas',
  params: [
    {
      description: 'The ID of the newly created duplicate canvas',
      name: 'canvasId',
      required: true,
      type: 'string',
    },
    {
      description: 'The ID of the canvas that was duplicated',
      name: 'sourceCanvasId',
      required: true,
      type: 'string',
    },
    {
      description: 'The location where the user duplicated the canvas',
      name: 'location',
      required: true,
      type: 'enum',
      values: [
        'action-bar',
        'account-settings-integrations',
        'asset-modal',
        'asset-details',
        'all-content-null-state',
        'board-collection-gallery',
        'board-container-null-state',
        'board-container-right-click',
        'board-select-modal',
        'board-side-panel',
        'board-stats-bar',
        'collection-stats-bar',
        'context-menu-bulk-edit',
        'create-workspace-page',
        'drag-n-drop',
        'dev-modal',
        'empty-board-add-content',
        'file-uploader',
        'gallery-context-menu',
        'gallery-item',
        'gallery-item-context-menu',
        'gallery-item-ellipsis-menu',
        'gallery-multi-select-context-menu',
        'gallery-multi-select-ellipsis-menu',
        'guest-invite-modal',
        'header',
        'header-bar-add-button',
        'kanban-view',
        'keyboard',
        'all-content',
        'library',
        'library-page',
        'library-page-context-menu',
        'mobile-bottom-nav',
        'move-items-modal',
        'move-items-confirmation-modal',
        'pdf-control-bar',
        'pdf-page-preview',
        'private-gallery-page',
        'private-kanban-page',
        'public-asset-page',
        'public-gallery-page',
        'public-kanban-page',
        'saved-filter',
        'share-collection-edit-modal',
        'side-nav-saved-filters',
        'side-nav-extension',
        'side-nav-footer',
        'side-nav-extension-end-button',
        'side-nav-extension-item-button',
        'side-nav-extension-item-context-menu',
        'side-nav-extension-item-ellipsis-menu',
        'side-nav-extension-item-sub-button',
        'side-nav-tree-item',
        'table-cell',
        'table-header',
        'table-item-context-menu',
        'table-item-ellipsis-menu',
        'table-multi-select-context-menu',
        'table-multi-select-ellipsis-menu',
        'tag-manager',
        'workspace-settings',
        'workspace-settings-security',
      ],
    },
    {
      description: 'The ID of the board the duplicate canvas was created in, if any',
      name: 'boardId',
      required: false,
      type: 'string',
    },
  ],
};

export default META;
